import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

export class PhoneUtils {
    public static FormatPhoneNumber(phoneNumber: string, addUnions: boolean): string {
        if (addUnions && phoneNumber.length === 10) {
            return this.FormatPhoneNumberWithUnions(phoneNumber);
        }
        return this.FormatPhoneNumberWithoutUnions(phoneNumber);
    }

    public static FilterPhoneByTypes(phone: PhoneNumber, phoneType: string, contactPointType: string, getLookupById: (id: string) => FlatLookupView): boolean {
        const typeLk = getLookupById(phone.PhoneTypeLookupId);
        const cpTypeLk = getLookupById(phone.ContactPointTypeLookupId);

        const typeLkCode = typeLk?.LookupCode || "";
        const cpTypeLkCode = cpTypeLk?.LookupCode || "";

        const hasPhoneTypeValidation = phoneType && phoneType !== "";
        const hasPhoneCpTypeValidation = contactPointType && contactPointType !== "";

        if (hasPhoneTypeValidation && typeLkCode !== phoneType) {
            return false;
        }

        if (hasPhoneCpTypeValidation && cpTypeLkCode !== contactPointType) {
            return false;
        }

        return true;
    }

    private static FormatPhoneNumberWithUnions(phoneNumber: string): string {
        return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
    }

    private static FormatPhoneNumberWithoutUnions(phoneNumber: string): string {
        return phoneNumber.replace(/[-()]/g, "");
    }
}
